export const FEEDBACK_ON_BUS_REDUCER = 'feedback-on-bus'

export const STEP_BUS_CHECKER_PERIODS = {
  SELECT_PERIOD: 'select-period',
  FORM_UPLOADER: 'form-uploader',
  LIST_DATA_UPLOADER: 'list-of-data-uploader'
}
  